import { withStyles, Grid } from '@material-ui/core';
import CustomConfirmationDialog from '../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog';

const styles = (theme) => ({
  proListContainer: {
    margin: '8px 0 8px 20px',
    padding: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  proItem: {
    wordBreak: 'break-all'
  }
});

const HoldProPopup = ({ classes, onCancel, holdProIdList = [], isRouteGrid = false }) => (
  <CustomConfirmationDialog
    title={isRouteGrid ? 'No changes allowed on Hold Pros' : 'Pro cannot be delivered'}
    confirmButtonLabel="OK"
    mode="danger"
    onConfirm={onCancel}
    onCancel={onCancel}
  >
    <Grid container spacing={24}>
      <Grid item xs={12}>
        {isRouteGrid ? (
          <span>On hold pros cannot be moved out of the trap route</span>
        ) : holdProIdList?.length === 1 ? (
          <span>
            {`PRO ${holdProIdList[0]} with an 'On Hold' status cannot be assigned to a city route.`}
          </span>
        ) : (
          <>
            <span>PRO(s) with an 'On Hold' status cannot be assigned to a city route.</span>
            <div className={classes.proListContainer}>
              {holdProIdList?.map((pro, idx) => (
                <span key={idx} className={classes.proItem}>
                  {pro}
                </span>
              ))}
            </div>
          </>
        )}
      </Grid>
    </Grid>
  </CustomConfirmationDialog>
);

export default withStyles(styles)(HoldProPopup);
